import { render, staticRenderFns } from "./Button-Primary.vue?vue&type=template&id=2fc78e88&scoped=true&"
import script from "./Button-Primary.vue?vue&type=script&lang=js&"
export * from "./Button-Primary.vue?vue&type=script&lang=js&"
import style0 from "./Button-Primary.vue?vue&type=style&index=0&id=2fc78e88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc78e88",
  null
  
)

export default component.exports